import { render, staticRenderFns } from "./SellBusinessAdd.vue?vue&type=template&id=72bd4ef4&scoped=true&"
import script from "./SellBusinessAdd.vue?vue&type=script&lang=js&"
export * from "./SellBusinessAdd.vue?vue&type=script&lang=js&"
import style0 from "./SellBusinessAdd.vue?vue&type=style&index=0&id=72bd4ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd4ef4",
  null
  
)

export default component.exports